import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from 'material-ui/IconButton';
import CloseHome from 'material-ui/svg-icons/navigation/close';

const Title = styled.h4`
    margin: 15px 0 5px;
`;

const List = styled.ul`
    margin: 0;
    padding-left: 0;
    font-size: 14px;
`;

const Item = styled.li`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 20px;

    ::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 6px;
        height: 6px;
        margin-top: -3px;
        border-radius: 50%;
        background-color: #4d4d4d;
    }
`;

const IconButtonStyle = {
    width: 24,
    height: 24,
    marginLeft: 10,
    padding: 0
};

const AddedItemsList = ({ title, itemIdList = [], mapItems = {}, handleDeleteItem }) => {
    if (!itemIdList.length || !Object.keys(mapItems).length) {
        return null;
    }

    return (
        <div>
            {title && <Title>{title}</Title>}
            <List>
                {itemIdList.map(itemId => (
                    <Item key={itemId}>
                        <span>{mapItems[itemId].name}</span>
                        {handleDeleteItem && (
                            <IconButton onClick={handleDeleteItem(itemId)} style={IconButtonStyle}>
                                <CloseHome />
                            </IconButton>
                        )}
                    </Item>
                ))}
            </List>
        </div>
    );
};

AddedItemsList.propTypes = {
    title: PropTypes.string,
    itemIdList: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
    mapItems: PropTypes.shape({
        name: PropTypes.string
    }).isRequired,
    handleDeleteItem: PropTypes.func
};

export default AddedItemsList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/AddInterestFormDialog/AddedItemsList.js
 **/